
import { Model } from 'backbone';

class ConnectionDetailsModel extends Model {

    initialize() {
    }

    defaults() {
        return {};
    }

    parse(response, options)  {
        return response;
    }
}

export default ConnectionDetailsModel;
